// src/components/modal/produtos/ConjuntoSelecaoModal.js
// components/modal/produtos/ConjuntoSelecaoModal.js
import React, { useState, useEffect, useMemo } from "react";
import { formatCurrency } from "../../../utils/numberUtils"; 
import ModalContainer from "../../modalForm/ModalContainer";  // usa seu modal padrão
import ModalHeader from "../../modalForm/ModalHeader";
import ModalBody from "../../modalForm/ModalBody";
import ModalFooter from "../../modalForm/ModalFooter";
import { ModalActionButton } from "../../modalForm/ModalActions";
import ModalQuantityControl from "../../modalForm/ModalQuantityControl";
import { FiLayers } from "react-icons/fi";
import "./ConjuntoSelecaoModal.css";

export default function ConjuntoSelecaoModal({
  show,
  onClose,
  conjunto,
  produto,
  pedidoItemSel,
  setPedidoItemSel,
  onConcluir,
  headerColors,
  aplicarRegrasConjunto = false,
}) {

  // Hooks DEVEM vir sempre antes de qualquer return condicional
  const [itensSel, setItensSel] = useState({});

  const gruposItens = useMemo(() => {
    const grupos = new Map();
    (conjunto?.items ?? []).forEach(item => {
      const variacao = (item.variacao || '').trim();
      if (!grupos.has(variacao)) grupos.set(variacao, []);
      grupos.get(variacao).push(item);
    });
    return Array.from(grupos, ([variacao, items]) => ({ variacao, items }));
  }, [conjunto]);

  useEffect(() => {
    if (!show || !conjunto) return;

    // if (!pedidoItemSel?.pedidoItemConjuntos) return;

    // const itensDoConjunto = pedidoItemSel.pedidoItemConjuntos.filter(
    //   x => x.conjuntoId === conjunto.id
    // );

    const lista = pedidoItemSel?.pedidoItemConjuntos || [];
    const itensDoConjunto = lista.filter(x => x.conjuntoId === conjunto.id);

    const inicial = {};
    itensDoConjunto.forEach(i => {
      inicial[i.conjuntoItemId] = i.qtdItens;
    });

    setItensSel(inicial);
  }, [show, conjunto]);

  const qtdTotal = useMemo(() => {
    return Object.values(itensSel).reduce((t, q) => t + q, 0);
  }, [itensSel]);

  const valorTotal = useMemo(() => {
    return (conjunto?.items ?? []).reduce((total, item) => {
      const qtd = itensSel[item.id] || 0;
      return total + qtd * (item.valorAdicional || 0);
    }, 0);
  }, [itensSel, conjunto]);

  const defineValorItem = aplicarRegrasConjunto && conjunto?.defineValorItem === true;
  const valorItemDefinido = useMemo(() => {
    const precoProduto = Number(produto?.preco || 0);
    if (!defineValorItem) return precoProduto;

    return (conjunto?.items ?? []).reduce((maiorValor, item) => {
      if ((itensSel[item.id] || 0) <= 0) return maiorValor;
      return Math.max(maiorValor, Number(item.valorAdicional || 0));
    }, precoProduto);
  }, [conjunto, defineValorItem, itensSel, produto]);

  // 🚨 Apenas aqui você avalia show e conjunto
  if (!show || !conjunto) return null;


  const alterarQtd = (itemId, delta) => {
    setItensSel((prev) => {
      const atual = prev[itemId] || 0;
      const novo = atual + delta;

      if (novo < 0) return prev;
      if (conjunto.qtdMax && qtdTotal + delta > conjunto.qtdMax) return prev;

      return { ...prev, [itemId]: novo };
    });
  };

  const handleConcluir = () => {
    const selecionados = conjunto.items
      .filter((i) => (itensSel[i.id] || 0) > 0)
      .map((i) => ({
        id: 0,
        pedidoItemId: pedidoItemSel?.id ?? 0,
        conjuntoId: conjunto.id,
        conjuntoNome: conjunto.nome,
        conjuntoItemId: i.id,
        conjuntoItemNome: i.produto.descricao,
        qtdItens: itensSel[i.id],
        valorAdicional: i.valorAdicional || 0,
      }));

    const listaAtual = pedidoItemSel?.pedidoItemConjuntos ?? [];
    const filtrados = listaAtual.filter((x) => x.conjuntoId !== conjunto.id);
    const novosConjuntos = [...filtrados, ...selecionados];

    // ✅ UNITÁRIO (por 1 item do pedido)
    const valorAdicionalConjUnit = novosConjuntos.reduce(
      (tot, item) => tot + (item.qtdItens || 0) * (item.valorAdicional || 0),
      0
    );

    // ✅ adicionais UNITÁRIO (não mexe aqui, quem soma adicionais é o modal pai)
    // então aqui só atualiza conjuntos e valorAdicional UNITÁRIO parcial.
    // O modal pai recalcula o TOTAL final (com adicionais + conjuntos).
    const pedidoItemAtualizado = {
      ...pedidoItemSel,
      pedidoItemConjuntos: novosConjuntos,
      // deixa unitário
      valorAdicional: valorAdicionalConjUnit,
    };

    // Entrega o objeto consolidado ao modal pai. O callback do pai também
    // recalcula quantidade e totais antes de atualizar a tela.
    setPedidoItemSel(pedidoItemAtualizado);

    if (onConcluir) onConcluir(pedidoItemAtualizado);
    onClose();
  };


  if (!show) return null;

  return (
    <ModalContainer
      show={show} variant="cadastro" onHide={onClose}
      largura="700px"
      contentClassName="conjunto-selecao-modal modal-operacional"
    >
      <ModalHeader title={conjunto.nome} icon={FiLayers} onHide={onClose} headerColors={headerColors} />
      <ModalBody>

      <div className="conjunto-selecao-contexto">
        <b>Produto:</b> {produto.descricao}
        <br />
          <b>{conjunto.nome}</b>{" "}
          {conjunto.qtdMax ? `(máx. ${conjunto.qtdMax})` : ""}
        
      </div>

      {/* LISTA EM GRID RESPONSIVO */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          paddingRight: "4px",
          marginRight: "-4px",
        }}
      >
        {gruposItens.map(({ variacao, items }) => (
          <section key={variacao} className="conjunto-selecao-grupo" aria-label={variacao || undefined}>
            {variacao && <h6 className="conjunto-selecao-variacao">{variacao}</h6>}
            <div className="conjunto-selecao-grid">
              {items.map((item) => {
                const qtd = itensSel[item.id] || 0;
                const selecionado = qtd > 0;

                return (
                  <div key={item.id} className={`conjunto-selecao-item${selecionado ? " selecionado" : ""}`}>
                    <button type="button" className="conjunto-selecao-selecionar"
                      aria-label={`Selecionar ${item.produto.descricao}`}
                      onClick={() => alterarQtd(item.id, +1)} />
                    {/* ITEM LABEL */}
                    <div className="conjunto-selecao-descricao">
                      <div className="conjunto-selecao-nome">
                        {item.produto.descricao}
                      </div>
                      {item.valorAdicional ? (
                        <div className="conjunto-selecao-preco">
                          {formatCurrency(item.valorAdicional)}
                        </div>
                      ) : null}
                    </div>

                    {/* BOTÕES QUANTIDADE */}
                    <ModalQuantityControl name={item.produto.descricao} value={qtd}
                      decreaseDisabled={!selecionado}
                      onDecrease={() => alterarQtd(item.id, -1)} onIncrease={() => alterarQtd(item.id, +1)} />
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>

      {/* RESUMO */}
      <div className="conjunto-selecao-resumo">
        <b>Itens adicionados:</b> {qtdTotal}
        <br />
        <b>{defineValorItem ? "Valor do item:" : "Valor adicional:"}</b>{" "}
        {formatCurrency(defineValorItem ? valorItemDefinido : valorTotal)}
      </div>
      </ModalBody>

      {/* FOOTER */}
      <ModalFooter>
        <ModalActionButton action="close" onClick={onClose}>Cancelar</ModalActionButton>
        <ModalActionButton action="confirm" onClick={handleConcluir}>Concluir</ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
}
